
import Button from "@/Components/Buttons/Button.vue";
import Card from "@/Components/General/Card.vue";
import Multiselect from "@/Components/General/Multiselect.vue";
import { PropType, defineComponent, onMounted } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiContentSave, mdiLoading, mdiPrinter } from "@mdi/js";
import { Invoice } from "@/types/Invoice";
import Pagination from "@/types/Pagination";
import InvoicesTable from "@/Components/Reports/InvoicesTable.vue";

export default defineComponent({
  props: {
    invoices: {
      type: Object as PropType<Pagination<Invoice>>,
      required: false,
    },
  },
  setup(props) {
    onMounted(() => {
      window.print();
    });

    return {
      print,
      mdiContentSave,
      mdiLoading,
      printIcon: mdiPrinter,
    };
  },
  components: { Multiselect, Card, Button, SvgIcon, InvoicesTable },
});
